import React from 'react';
import { ZapIcon, BadgeDollarSignIcon, UsersIcon, PackageCheckIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const icons = [ZapIcon, BadgeDollarSignIcon, UsersIcon, PackageCheckIcon];
export function WhyChooseUs() {
  const {
    t
  } = useLanguage();
  return <section id="why-us" className="w-full bg-forest py-20 lg:py-28" data-id="element-213" data-mp="u6m5grepnbiu">
      <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-[minmax(0,0.85fr)_minmax(0,1.15fr)] lg:gap-16 lg:px-8" data-id="element-214" data-mp="g7mkpuubjgry">
        <div data-id="element-215" data-mp="l6zdew7vfi2g">
          <h2 className="font-display text-3xl font-black leading-tight tracking-tight text-white sm:text-4xl lg:text-5xl" data-id="element-216" data-mp="l7in5pndb05e">
            {t.why.title}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-white/75" data-id="element-217" data-mp="b89z1df6ofqy">
            {t.why.intro}
          </p>
          <dl className="mt-8 flex gap-10 border-t border-white/15 pt-8" data-id="element-218" data-mp="21kfqqd64fv5c">
            <div data-id="element-219" data-mp="25mkjl9oqwnqx">
              <dt className="text-sm font-semibold text-white/60" data-id="element-220" data-mp="25n2osvtdycaz">
                {t.why.basedInLabel}
              </dt>
              <dd className="font-display text-lg font-bold text-white" data-id="element-221" data-mp="1ndlpobb0oet7">
                {t.why.basedInValue}
              </dd>
            </div>
            <div data-id="element-222" data-mp="1idpsauwtrlmm">
              <dt className="text-sm font-semibold text-white/60" data-id="element-223" data-mp="1x46tcd5js9iz">
                {t.why.servingLabel}
              </dt>
              <dd className="font-display text-lg font-bold text-white" data-id="element-224" data-mp="1s53qmzd1ife6">
                {t.why.servingValue}
              </dd>
            </div>
          </dl>
        </div>

        <ul className="grid gap-px overflow-hidden rounded-lg bg-white/15 sm:grid-cols-2" data-id="element-225" data-mp="zgy3y72fegbp">
          {t.why.items.map((benefit, index) => {
          const Icon = icons[index];
          return <li key={benefit.title} className="bg-forest p-7" data-id="element-226" data-mp="19f5jqmkzasc4" data-mpi={index}>
                <Icon className="h-7 w-7 text-rust-light" aria-hidden="true" data-id="element-227" data-mp="19gyqe1vldck4" />
                <h3 className="mt-5 font-display text-lg font-bold text-white" data-id="element-228" data-mp="2prkk1tink8un">
                  {benefit.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-white/70" data-id="element-229" data-mp="2rx93nkpidq8q">
                  {benefit.description}
                </p>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}